import { render, staticRenderFns } from "./CamaraHistoricoPantalla.vue?vue&type=template&id=6f1057b6&scoped=true&"
import script from "./CamaraHistoricoPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraHistoricoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1057b6",
  null
  
)

export default component.exports